import CareTypeGroup from './CareTypeGroup';

/**
 * CareTimelineSection — one time-window section in the Pflegekalender
 * (e.g. "Aktuell relevant", "Demnächst", "Später").
 */
const CareTimelineSection = ({ title, groups, emptyText }) => (
  <section>
    <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3 sticky top-0 z-10 bg-white py-2 -mx-4 px-4 md:static md:bg-transparent md:py-0 md:mx-0 md:px-0">
      {title}
    </h3>
    {groups.length === 0 ? (
      <p className="text-[13px] text-gray-500">{emptyText}</p>
    ) : (
      <div className="bg-white rounded-xl shadow-sm px-4">
        {groups.map((group) => (
          <CareTypeGroup key={group.type} {...group} />
        ))}
      </div>
    )}
  </section>
);

export default CareTimelineSection;
